import { Button } from 'src/components/FormComponents/Submit/Submit.styles'
import styled from 'styled-components'

export const Label = styled.label`
  display: flex;
  flex-direction: column;

  padding: 1rem 2rem;
  font-size: 1.2rem;
  text-transform: capitalize;
  font-weight: bold;

  border: 1px solid #c7c9c7;
`

export const Submit = styled(Button)`
  height: 4rem;
`

export const Input = styled.input``

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  margin-left: auto;
  margin-right: auto;
  margin-top: 2rem;


  width: 60%;
  height: 15rem;
`
